import HttpClienteSeguroCajas from '../../Servicios/HttpClienteSeguroCajas';

/**
 * solicitar pago portal
 * @param {{invoiceId:string, urlRetorno:string,
 * peticionUsuario:{ companyId:string, userId:string, optionId:string, action:string } }} objectRequest
 * @returns {Promise<{data:{datos:number, url:string }, status:number }>}
 */
export const solicitudPagoPortal = (objectRequest) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCajas.post("/FacturaPago/SolicitudPagoPortal", objectRequest).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

/**
 * valida pago en linea
 * @param {{companyId:string, campusId:string,
 * peticionUsuario:{ companyId:string, userId:string, optionId:string, action:string } }} objectRequest
 * @returns {Promise<{data:boolean, status:number }>}
 */
export const validaPagoEnlineaActivo = (objectRequest) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCajas.post("/FacturaPago/ValidaPagoEnlineaActivo", objectRequest).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

/**
 * valida el pago proceso banco
 * @param {{invoiceId:string,
 * peticionUsuario:{ companyId:string, userId:string, optionId:string, action:string } }} objectRequest
 * @returns {Promise<{data:boolean, status:number }>}
 */
export const validaPagoEnProcesolinea = (objectRequest) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCajas.post("/FacturaPago/ValidaPagoLinea", objectRequest).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

/**
 * Valida directamente en BD si el pago de la factura se concilió (factura
 * cobrada), sin consultar al Centro de Pagos externo. Usado al volver de la
 * pasarela para constatar el pago de la factura puntual.
 * @param {{invoiceId:string,
 * peticionUsuario:{ companyId:string, userId:string, optionId:string, action:string } }} objectRequest
 * @returns {Promise<{data:boolean, status:number }>} data: true = pago realizado
 */
export const validarPagoInvoice = (objectRequest) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCajas.post("/FacturaPago/ValidarPagoInvoice", objectRequest).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};
